import { DurationType } from "@gymflow/common";
import z from "zod";

import { AddonSchema } from "./AddonSchema";

export const TrialMembershipSchema = z.object({
  name: z
    .string()
    .min(3, "Must be at least 3 characters")
    .max(100, "Must be shorter than 100 characters")
    .default(""),
  description: z
    .string()
    .max(500, "Must be shorter than 500 characters")
    .optional(),
  "upfront-addons": z.array(AddonSchema).default([]),
  "default-price": z.object({
    exTaxPrice: z.number().min(0).optional().default(0),
    incTaxPrice: z.number().min(0).optional().default(0),
    salesTaxRate: z.number().min(0).max(100).optional().default(0),
  }),
  "is-public": z.boolean().default(false),
  "duration-type": z.enum([
    DurationType.Daily,
    DurationType.Weekly,
    DurationType.Monthly,
    DurationType.NoContract,
  ]),
  duration: z.number(),
  "is-trial": z.literal(true),
  "terms-conditions": z.object(
    { name: z.string() },
    {
      invalid_type_error: "Terms and Conditions are required",
      required_error: "Terms and Conditions are required",
    },
  ),
  "fixed-start-date": z.string().optional(),
  "for-members-only": z.boolean().default(false),
});

export type TrialMembershipType = z.infer<typeof TrialMembershipSchema>;
export type TrialMembershipSchemaKeys = keyof z.infer<
  typeof TrialMembershipSchema
>;
